import { render, staticRenderFns } from "./search-modal-cmp.vue?vue&type=template&id=28685671&scoped=true"
import script from "./search-modal-cmp.vue?vue&type=script&lang=js"
export * from "./search-modal-cmp.vue?vue&type=script&lang=js"
import style0 from "./search-modal-cmp.vue?vue&type=style&index=0&id=28685671&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28685671",
  null
  
)

export default component.exports